// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface IdCardIconSignature {
  Element: SVGSVGElement;
}

export const IdCardIcon: TOC<IdCardIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.00101 4H20.001C21.101 4 22.001 4.9 22.001 6V18C22.001 19.1 21.101 20 20.001 20H4.00101C2.90101 20 2.00101 19.1 2.00101 18V6C2.00101 4.9 2.90101 4 4.00101 4ZM4.00101 18H20.001V6H4.00101V18ZM14.001 11H18.001V13H14.001V11ZM18.001 14H14.001V16H18.001V14ZM6.00101 16C6.00101 14.159 7.16001 13 9.00101 13C10.842 13 12.001 14.159 12.001 16H6.00101ZM9.00101 12C10.1056 12 11.001 11.1046 11.001 10C11.001 8.89543 10.1056 8 9.00101 8C7.89644 8 7.00101 8.89543 7.00101 10C7.00101 11.1046 7.89644 12 9.00101 12Z"/>
</svg>
</template>;